module.exports = __webpack_public_path__ + "img/face3.a42eb4be.jpg";